var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"elite-content_body_inner_header"},[_c('div',{staticClass:"elite-content_body_inner_header_left"},[_c('i',{staticClass:"far fa-home"}),_c('h1',[_vm._v(_vm._s(_vm.$t("COMMON.DASHBOARD")))])])]),_c('div',{staticClass:"elite-content_body_inner_container"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }